import React, {useContext} from "react";
import Rest from "../helpers/Rest";

const PATH = "device/"

export const Devices = React.createContext(null)

export class DevicesContext extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            fetchDevices: this.fetchDevices.bind(this),
            fetchDeviceById: this.fetchDeviceById.bind(this),
            replaceMaster: this.replaceMaster.bind(this)
        }
    }

    update(device) {
        const {devices} = this.state
        if (!devices){
            return
        }
        const id = device[0]
        const old = devices.map[id]
        if (old) {
            device.forEach((val, idx) => old[idx] = val)
        }
        else{
            devices.map[id] = device
            devices.list.push(device)
        }
    }

    async fetchDeviceById(id){
        const device = await Rest.get(PATH + id)
        this.update(device)
        return device
    }

    async replaceMaster(oldId, newId, flags) {
        await Rest.post(`${PATH}${oldId}/replace`, {
            new_device_id: newId,
            ...flags
        })
        await this.fetchDeviceById(oldId)
        return await this.fetchDeviceById(newId)
    }

    async removeDevices(ids){
        await Promise.all(ids.map(id => Rest.del(PATH + id)))
        this.setState({
            devices: null
        })
    }

    addDevice(device){
        const devices = this.state.devices
        devices.list.push(device)
        devices.map[device[0]] = device
    }

    async fetchDevices() {
        if (this.state.devices){
            return this.state.devices
        }
        const list = await Rest.get(PATH + "list")
        const devices = {
            list: list,
            map: list.reduce((accum, item) => {
                accum[item[0]] = item
                return accum
            }, {}),
            remove: this.removeDevices.bind(this),
            add: this.addDevice.bind(this)
        }
        this.setState({devices: devices})
        return devices
    }

    render(){
        return (
            <Devices.Provider value={this.state}>
                {this.props.children}
            </Devices.Provider>
        )
    }
}

export function useDevices(){
    const devices = useContext(Devices)
    if (!devices){
        throw new Error("No DevicesContext")
    }
    return devices
}
